<template>
	<div class="w-full h-full flex flex-col items-center hierarchy-select px-4">
		<HierarchySelect
			ref="hierarchySelect"
			:value="filters.modules"
			key-name="modules"
			identifier="module"
			:level="1"
			@change="$emit('change')"
		/>
	</div>
</template>

<script>
	import HierarchySelect from '@/components/shared/HierarchySelect'

	export default {
		name: 'Filters',
		components: {
			HierarchySelect,
		},
		props: {
			filters: {
				type: Object,
				required: true,
			},
		},
		data() {
			return {
				selectAll: false,
			}
		},
		methods: {},
	}
</script>

<style lang="scss" scoped></style>
